module.exports = __webpack_public_path__ + "static/media/mobpsycho.67de7b7f.png";